var _class;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Vector2d } from "@stage/math";
import { Vector2ds } from "./Vector2d";
import { Transforms } from "./Transforms";
export var Box = /*#__PURE__*/function () {
  function Box() {
    _classCallCheck(this, Box);
    _defineProperty(this, "x", void 0);
    _defineProperty(this, "y", void 0);
    _defineProperty(this, "width", void 0);
    _defineProperty(this, "height", void 0);
    _defineProperty(this, "rotate", void 0);
  }
  _createClass(Box, null, [{
    key: "pivot",
    value: function pivot(box) {
      return {
        x: box.x + box.width / 2,
        y: box.y + box.height / 2
      };
    }
  }, {
    key: "offset",
    value: function offset(box, placement) {
      var placementOrigin = Transforms.Origin.Placement(placement);
      return Transforms.Origin.Normalize(box, placementOrigin);
    }
  }]);
  return Box;
}();

// interface BasicBoxTransform {
//   origin: Boxs.BoxTransformOrigin;
// }
// export interface BoxTranslate {
//
// }
_class = Box;
_defineProperty(Box, "normalized", function normalized(box, offset) {
  return Vector2d.rotate(Vector2d.add({
    x: box.x,
    y: box.y
  }, offset), box.rotate, _class.pivot(box));
});
export var Boxs;
(function (_Boxs) {
  function translate(box, translate) {
    return _objectSpread(_objectSpread({}, box), Vector2d.add(box, translate));
  }
  _Boxs.translate = translate;
  function contain(box, vec) {
    var x = box.x,
      y = box.y,
      width = box.width,
      height = box.height,
      rotate = box.rotate;
    var transformOrigin = {
      x: x + width / 2,
      y: y + height / 2
    };

    //点经旋转变换后的位置
    var transformedPoint = Vector2ds.rotate(vec, -rotate, transformOrigin);
    var maxX = x + width;
    var maxY = y + height;
    return transformedPoint.x >= x && transformedPoint.y >= y && transformedPoint.x <= maxX && transformedPoint.y <= maxY;
  }
  _Boxs.contain = contain;
  function rotateWithOrigin(box, rotate, origin) {
    var width = box.width,
      height = box.height;
    var boxPivot = Box.pivot(box);
    var transformedBoxPivot = Vector2ds.rotate(boxPivot, rotate, origin);
    return {
      x: transformedBoxPivot.x - width / 2,
      y: transformedBoxPivot.y - height / 2,
      width: width,
      height: height,
      rotate: box.rotate + rotate
    };
  }
  _Boxs.rotateWithOrigin = rotateWithOrigin;
  function unwrap(box) {
    for (var _len = arguments.length, parents = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      parents[_key - 1] = arguments[_key];
    }
    return (parents === null || parents === void 0 ? void 0 : parents.length) > 0 ? parents.reduce(function (value, parent) {
      var _parent$rotate;
      var rotatedBox = rotateWithOrigin(value, (_parent$rotate = parent === null || parent === void 0 ? void 0 : parent.rotate) !== null && _parent$rotate !== void 0 ? _parent$rotate : 0, {
        x: parent.width / 2,
        y: parent.height / 2
      });
      return _objectSpread(_objectSpread({}, rotatedBox), Vector2ds.translate(rotatedBox, {
        x: parent.x,
        y: parent.y
      }));
    }, box) : box;
  }
  _Boxs.unwrap = unwrap;
  function preserveAspectRatio(transform, preserve, aspectRatio) {
    if (preserve === 'x') {
      return _objectSpread(_objectSpread({}, transform), {}, {
        x: transform.x,
        y: transform.x / aspectRatio
      });
    } else {
      return _objectSpread(_objectSpread({}, transform), {}, {
        x: transform.y * aspectRatio,
        y: transform.y
      });
    }
  }
  _Boxs.preserveAspectRatio = preserveAspectRatio;
  function byTransformOrigin(box) {
    var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      xOffset: 'left',
      yOffset: 'top'
    };
    var originX, originY;
    switch (origin.xOffset) {
      case 'left':
        originX = 0;
        break;
      case 'center':
        originX = box.width / 2;
        break;
      case 'right':
        originX = box.width;
        break;
      default:
        originX = origin.xOffset;
        break;
    }
    switch (origin.yOffset) {
      case 'top':
        originY = 0;
        break;
      case 'center':
        originY = box.height / 2;
        break;
      case 'bottom':
        originY = box.height;
        break;
      default:
        originY = origin.yOffset;
        break;
    }
    return {
      x: originX,
      y: originY
    };
  }
  _Boxs.byTransformOrigin = byTransformOrigin;
  function offsetOfTransform(box, offset, transformOrigin) {
    var pivot = Box.pivot(box);
    //偏移变换原点
    var origin = Vector2ds.translate({
      x: box.x,
      y: box.y
    }, byTransformOrigin(box, transformOrigin));
    // const origin: IVector2d = {
    //   x: box.x,
    //   y: box.y
    // };

    // console.log(boxPivot) 正确
    //进行偏移
    var transformedPivot = Vector2ds.translate(pivot, offset);

    //还原为盒子的固定点
    var transformedOrigin = Vector2ds.rotate(Vector2ds.rotate(origin, box.rotate, pivot), -box.rotate, transformedPivot);
    // console.log(origin, Vector2ds.rotate(origin, box.rotate, pivot))
    // console.log(offset, transformedOrigin, origin, Vector2ds.rotate(origin, box.rotate, pivot))
    //经过offset之后，2个固定点偏移量
    return {
      x: transformedOrigin.x - origin.x,
      y: transformedOrigin.y - origin.y
    };
  }
  _Boxs.offsetOfTransform = offsetOfTransform;
  function radio(box, radio) {
    var x = box.x,
      y = box.y,
      width = box.width,
      height = box.height,
      rotate = box.rotate;
    return {
      x: x * radio,
      y: y * radio,
      width: width * radio,
      height: height * radio,
      rotate: rotate
    };
  }
  _Boxs.radio = radio;
  function scale(box, transform) {
    var origin = transform.origin,
      sx = transform.sx,
      sy = transform.sy;
    return resize(box, {
      origin: origin,
      x: box.width * (sx - 1),
      y: box.height * (sy - 1)
    });
  }
  _Boxs.scale = scale;
  function resize(box, transform) {
    var _transform$x = transform.x,
      x = _transform$x === void 0 ? 0 : _transform$x,
      _transform$y = transform.y,
      y = _transform$y === void 0 ? 0 : _transform$y,
      origin = transform.origin;
    var transformOrigin = byTransformOrigin(box, origin);
    var delta = {
      x: x,
      y: y
      // x: width - box.width,
      // y: height - box.height
    };
    var translate = {
      x: -delta.x * (transformOrigin.x / box.width),
      y: -delta.y * (transformOrigin.y / box.height)
    };
    var originTranslate = {
      x: delta.x * (0.5 - transformOrigin.x / box.width),
      y: delta.y * (0.5 - transformOrigin.y / box.height)
    };
    var offset = offsetOfTransform(box, Vector2ds.rotate(originTranslate, box.rotate), origin);
    return {
      x: box.x + translate.x + offset.x,
      y: box.y + translate.y + offset.y,
      width: box.width + delta.x,
      height: box.height + delta.y,
      rotate: box.rotate
    };
  }
  _Boxs.resize = resize;
  function rotate(box, transform) {
    var origin = transform.origin,
      rotate = transform.rotate;
    var transformOrigin = byTransformOrigin(box, origin);
    return rotateWithOrigin(box, rotate, {
      x: box.x + transformOrigin.x,
      y: box.y + transformOrigin.y
    });
  }
  _Boxs.rotate = rotate;
})(Boxs || (Boxs = {}));